import { ReflectUtils } from "@dooboostore/core";
import { MetaDataPropertyAtomic } from "../MetaDataAtomic.js";
import { ObjectUtils } from "@dooboostore/core";
const AfterMetadataKey = Symbol.for("simple-boot:after-metadata");
const BeforeMetadataKey = Symbol.for("simple-boot:before-metadata");
const AroundMetadataKey = Symbol.for("simple-boot:around-metadata");
const After = (data) => {
  return ReflectUtils.metadata(AfterMetadataKey, data);
};
const getAfter = (target, propertyKey) => {
  return ReflectUtils.getMetadata(AfterMetadataKey, target, propertyKey);
};
const getAfters = (target) => {
  return ObjectUtils.allProtoTypeName(target).map((it) => new MetaDataPropertyAtomic(target, getAfter(target, it), it)).filter((it) => it.metaData !== void 0) || [];
};
const getProtoAfters = (target, propertyKey, type) => {
  return getAfters(target).filter((it) => propertyKey === it.metaData?.property && type === it.metaData.type?.prototype) || [];
};
const Before = (data) => {
  return ReflectUtils.metadata(BeforeMetadataKey, data);
};
const getBefore = (target, propertyKey) => {
  return ReflectUtils.getMetadata(BeforeMetadataKey, target, propertyKey);
};
const getBefores = (target) => {
  return ObjectUtils.allProtoTypeName(target).map((it) => new MetaDataPropertyAtomic(target, getBefore(target, it), it)).filter((it) => it.metaData !== void 0) || [];
};
const getProtoBefores = (target, propertyKey, type) => {
  return getBefores(target).filter((it) => propertyKey === it.metaData?.property && type === it.metaData.type?.prototype) || [];
};
class AroundForceReturn {
  constructor(value) {
    this.value = value;
  }
}
const Around = (config) => {
  return (target, propertyKey, descriptor) => {
    ReflectUtils.defineMetadata(AroundMetadataKey, config, target, propertyKey);
    const method = descriptor.value;
    descriptor.value = function(...args) {
      let before2 = void 0;
      let r = void 0;
      if (config.before) {
        try {
          before2 = config.before?.(this, propertyKey, args);
        } catch (e) {
          if (e instanceof AroundForceReturn) {
            return e.value;
          }
        }
        r = method.apply(this, before2);
      } else {
        r = method.apply(this, args);
      }
      if (config.after) {
        try {
          r = config.after?.(this, propertyKey, args, r);
        } catch (e) {
          if (e instanceof AroundForceReturn) {
            return e.value;
          }
        }
      }
      return r;
    };
  };
};
const getAround = (target, propertyKey) => {
  return ReflectUtils.getMetadata(AroundMetadataKey, target, propertyKey);
};
const after = After;
const before = Before;
const around = Around;
export {
  After,
  Around,
  AroundForceReturn,
  Before,
  after,
  around,
  before,
  getAfter,
  getAfters,
  getAround,
  getBefore,
  getBefores,
  getProtoAfters,
  getProtoBefores
};
//# sourceMappingURL=AOPDecorator.js.map
